import { useCallback, useMemo } from "react";
import { useFormContext, useController } from "react-hook-form";
import CrewSignatureCapture from "src/components/shared/CrewSignatureCapture/CrewSignatureCapture";
import { IUser } from "src/components/shared/UserList/UserList.types";
import { useGetApi } from "src/hooks/useGetApi";
import { useSelector } from "src/redux/hooks";

interface Props {
  id: string;
  cellCase?: string;
}

const MedicationAcceptance = ({ id }: Props) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name: id,
    defaultValue: null,
  });
  const { URN } = useSelector(state => state.medicalHistory.patientInformation);

  const { data: userList, isLoading } = useGetApi({
    request: "get-settings",
    body: {
      params: {
        sect: "_userlist",
      },
    },
    mapper: useCallback((data: any) => {
      return (
        (data?.data?.content?.users as IUser[])?.filter(
          crew => crew.active === 1 || crew.active === undefined,
        ) || []
      );
    }, []),
  });

  const users = useMemo(() => {
    return userList || [];
  }, [userList]);

  const defaultUser = useMemo(() => {
    return users.find(
      user => parseInt(user.ref) === parseInt(URN as unknown as string),
    )?.userid;
  }, [users]);

  return (
    <CrewSignatureCapture
      field={field as any}
      users={users}
      defaultUser={defaultUser}
      isLoading={isLoading}
      title="Medication Acceptance"
      description="Select crew member and sign to confirm acceptance of medication"
    />
  );
};

export default MedicationAcceptance;
